<template>
  <div class="scrap-batch-dialog">
    <custom-dialog width="60%" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="btn-group ub">
          <div class="btn-add ub-f1">
            <input type="file" ref="file" id="file" multiple="multiple" @change="handleFile" />
            <div style="display: inline-block">
              <i class="icon icon-add"></i>
              <span>{{ $t('dms_scrap_batch_dialog.qxzmbgswj')  }}</span>
            </div>
          </div>
          <div class="btn-tpl" @click="onDownloadTpl">
            <div style="display: inline-block">
              <i class="icon icon-daochu"></i>
              <span>{{ $t('dms_scrap_batch_dialog.bao_fei_mu_ban')  }}</span>
            </div>
          </div>
        </div>
        <div v-if="tip" class="result" v-html="tip"></div>
        <div class="search" style="height: 40px; overflow: hidden">
          <el-form :inline="true">
            <el-form-item>
              <el-button @click="showOk = true" :type="showOk ? 'primary' : ''" :plain="!showOk">{{ $t('dms_scrap_batch_dialog.tong_guo') }}（{{ okNum }}）</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="showOk = false" :type="!showOk ? 'primary' : ''" :plain="showOk">{{ $t('dms_scrap_batch_dialog.bu_tong_guo') }}（{{ failNum }}）</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 验证通过 -->
        <div v-show="showOk">
          <custom-table :data="okList" tableCode="scrap_batch_check" :filterArr="['errorMsg']"></custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="okNum"
              @size-change="onSizeChange1"
              @current-change="onCurrentPage1"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="okNum"
            ></el-pagination>
          </div>
        </div>
        <!-- 验证失败 -->
        <div v-show="!showOk">
          <custom-table :data="failList" tableCode="scrap_batch_check"></custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="failNum"
              @size-change="onSizeChange2"
              @current-change="onCurrentPage2"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="failNum"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button v-if="showOk" type="primary" :disabled="!okForm.flag || !okNum" @click="saveInStock">
          {{ $t('dms_scrap_batch_dialog.que_ding_dao_ru') }}
        </el-button>
        <el-button v-else type="primary" :disabled="!okForm.flag || !failNum" @click="onDownloadFail">{{ $t('Common.com_export') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      okForm: {
        flag: '',
        type: 'ok',
        pageNum: 1,
        pageSize: 50,
      },
      failForm: {
        flag: '',
        type: 'fail',
        pageNum: 1,
        pageSize: 50,
      },
      failList: [],
      failNum: 0,
      okList: [],
      okNum: 0,
      showOk: true,
      tip: '',
    };
  },
  mounted() {},
  methods: {
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.DeviceScrapDownloadTemplate);
    },
    // 异常导出
    onDownloadFail: function () {
      this.$exportFlie(apis.DeviceScrapExcelExportFailData, { flag: this.okForm.flag });
    },
    // 文件上传
    handleFile: function (e) {
      this.$postFile(apis.DeviceScrapExcel, e, {
        okPageSize: this.okForm.pageSize,
        failPageSize: this.failForm.pageSize,
      })
        .then((res) => {
          this.$message({ message: this.$t('Common.com_handle_success'), type: 'success' });
          this.$refs.file.value = '';
          this.failList = res.data.failList.list || [];
          this.failNum = res.data.failNum || 0;
          this.okList = res.data.okList.list || [];
          this.okNum = res.data.okNum || 0;
          this.okForm.flag = res.data.flag;
          this.failForm.flag = res.data.flag;
          const total = this.failNum + this.okNum;
          this.tip = this.$t('dms_scrap_batch_dialog.bcydrotsbqspantsbwtg', [total,this.okNum,this.failNum]);
        })
        .catch(() => {
          this.$refs.file.value = '';
        });
    },
    // 获取检测列表分页
    getInStockPage1: function () {
      this.$getJSON(apis.DeviceScrapExcelCheckPage, this.okForm).then((res) => {
        this.okList = res.data.list;
      });
    },
    // 获取检测列表分页
    getInStockPage2: function () {
      this.$getJSON(apis.DeviceScrapExcelCheckPage, this.failForm).then((res) => {
        this.failList = res.data.list;
      });
    },
    // 切换页
    onCurrentPage1: function (page) {
      this.okForm.pageNum = page;
      this.getInStockPage1();
    },
    // 切换每页数量
    onSizeChange1: function (size) {
      this.okForm.pageSize = size;
      this.getInStockPage1();
    },
    // 切换页
    onCurrentPage2: function (page) {
      this.failForm.pageNum = page;
      this.getInStockPage2();
    },
    // 切换每页数量
    onSizeChange2: function (size) {
      this.failForm.pageSize = size;
      this.getInStockPage2();
    },
    // 保存入库
    saveInStock: function () {
      this.$postJSON(`${apis.DeviceScrapBatch}/${this.okForm.flag}`).then((res) => {
        this.okForm.changeId = res.data;
        this.$postJSON(`${apis.apsApproveApprovalApproveStart}/device_scrap/${this.okForm.changeId}`, this.okForm, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.$emit('success');
          this.visible = false;
        });

      });
    },
  },
};
</script>

<style lang="scss">
.scrap-batch-dialog {
  .btn-group {
    margin-bottom: 20px;
    .btn-add {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      cursor: pointer;
      input {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .btn-tpl {
      width: 162px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(228, 228, 228, 1);
      margin-left: 10px;
      color: #333333;
      font-size: 12px;
      cursor: pointer;
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
  .result {
    padding: 6px 10px 0;
    color: #262626;
    font-size: 12px;
    height: 40px;
    .ok {
      color: blue;
    }
    .fail {
      color: red;
    }
  }
}
</style>
